import Modules from '@app/modules';
Modules.register({
    namespace: 'HBD/Reference',
    blocks: {
        'reference': function () { return import('@app/modules/HBD/Reference/Blocks/Reference.vue'); },
        'reference-slider': function () { return import('@app/modules/HBD/Reference/Blocks/ReferenceSlider.vue'); },
    }
});
